import type { DependencyList } from 'react';

const objectIds = new WeakMap<object, number>();
let nextObjectId = 0;

function objectDependencyId(value: object): number {
  const existing = objectIds.get(value);
  if (existing !== undefined) return existing;
  const id = ++nextObjectId;
  objectIds.set(value, id);
  return id;
}

function dependencyPart(value: unknown): string {
  if (typeof value === 'function' || (typeof value === 'object' && value !== null)) {
    return `${typeof value}:${objectDependencyId(value)}`;
  }
  if (typeof value === 'number') {
    if (Number.isNaN(value)) return 'number:NaN';
    if (Object.is(value, -0)) return 'number:-0';
  }
  return `${typeof value}:${String(value)}`;
}

export function dependencyListKey(deps: DependencyList): string {
  return deps.map(dependencyPart).join('|');
}
